const env = import.meta.env.REACT_APP_ENV! as 'prod' | 'staging' | 'dev'

const fallbackDocumentTypeIdMap = { dev: '3f1utvxqhvyworop', staging: '125p86nqvywh6a62', prod: '605z4iockl43kv8g' }

export const FALLBACK_DOCUMENT_TYPE_ID = fallbackDocumentTypeIdMap[env]

export interface DocumentTypeDetectionConfig {
  description: string
  documentLabels: string[]
}

export interface DocumentType {
  id: string
  name: string
  isActive: boolean
  detectionConfig: DocumentTypeDetectionConfig
  systemDocumentTypeId?: string
  metadata: { [key: string]: any }
}
